module.exports = __webpack_public_path__ + "img/ep5-5.6c1cf4c3.png";